import { render, staticRenderFns } from "./TagsIcon.vue?vue&type=template&id=881ad016&scoped=true&"
import script from "./TagsIcon.vue?vue&type=script&lang=js&"
export * from "./TagsIcon.vue?vue&type=script&lang=js&"
import style0 from "./TagsIcon.vue?vue&type=style&index=0&id=881ad016&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881ad016",
  null
  
)

export default component.exports